import { render, staticRenderFns } from "./coderProCodingFindings.vue?vue&type=template&id=5245f372&scoped=true&"
import script from "./coderProCodingFindings.vue?vue&type=script&lang=js&"
export * from "./coderProCodingFindings.vue?vue&type=script&lang=js&"
import style0 from "./coderProCodingFindings.vue?vue&type=style&index=0&id=5245f372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245f372",
  null
  
)

export default component.exports